import React from 'react';
import { TemplateBox } from '../TemplateBox';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '~/UIKit/Style';
import { PRIMARY_BLUE } from '../../../Constants/Colors.constants';
import { useUploadBox } from './useUploadBox';
import { ImportState } from '../../../Models/DTO/Import.model';
import { ImportUpload } from '../../../Components/Icons/ImportUpload';
import { ImportUpdate } from '../../../Components/Icons/ImportUpdate';
import { Error } from '~/Components';

interface IUploadBoxProps {
  className?: string;
}

const useUploadBoxStyles = makeStyles(() => ({
  uploadContainer: {
    '&:focus': {
      outline: `1px solid ${PRIMARY_BLUE}`,
    },
  },
}));

const isUploadInProgress = (uploadStatus: ImportState) =>
  (['New', 'ParsingFile'] as ImportState[]).includes(uploadStatus);

export const UploadBox = ({ className }: IUploadBoxProps) => {
  const {
    rootProps,
    inputProps,
    isActive,
    uploading,
    isFocused,
    uploadStatus,
    importError,
  } = useUploadBox();
  const { t } = useTranslation();
  const { classes: classnames } = useUploadBoxStyles();

  const processing = isUploadInProgress(uploadStatus);
  const description = processing
    ? t('app.import.uploadingDescription')
    : t('app.import.uploadFile.description');

  return (
    <div className={className || ''}>
      <input {...inputProps} />
      <div className={classnames.uploadContainer} {...rootProps}>
        <TemplateBox
          buttonText={t('app.import.uploadFile.button')}
          description={description}
          highlight={isActive || isFocused}
          icon={processing ? <ImportUpdate /> : <ImportUpload />}
          title={t('app.import.uploadFile')}
          loading={uploading}
          hideButton={processing}
          buttonType="button"
        />
      </div>
      <Error error={importError} />
    </div>
  );
};
